export class CompanyPlan {
    id:number
    del:boolean
    name:string
    all:number
    done:number
    errors:number
    deleted:number
    pending:number
    deleted_done:number
    pending_sync:number
    pending_review:number
    pending_connect:number
    error_account_connector:number

    fillFilteredDomain(data, screen_data, selected_field, hide_deleted = true){
        const companies = [];
        for(let i = 0; i < data.length; i++){
                const company = new CompanyPlan();
                company.id = data[i].id;
                company.del = data[i].del;
                company.name = data[i].name;
                company.all = data[i].states.all;
                company.done = data[i].states.done;
                company.errors = data[i].states.errors;
                company.deleted = data[i].states.deleted;
                company.pending = data[i].states.pending;
                company.deleted_done = data[i].states.deleted_done;
                company.pending_sync = data[i].states.pending_sync;
                company.pending_review = data[i].states.pending_review;
                company.pending_connect = data[i].states.pending_connect;
                company.error_account_connector = data[i].states.error_account_connector;
                companies.push(company);
        }
        const filas = [];
        for(let i = 0; i < companies.length; i++){
            if(hide_deleted && companies[i].del && companies[i].name !== "Total"){
                continue;
            }
            if(screen_data.search === '' || screen_data.search === null ||
                companies[i].name.toLowerCase().includes(screen_data.search.toLowerCase()) ||
                companies[i].name === "Total"
            ){
                    const fila = {
                        id: null,
                        del: null,
                        name: null,
                        states: {
                            all: null,
                            done: null,
                            errors: null,
                            deleted: null,
                            pending: null,
                            deleted_done: null,
                            pending_sync: null,
                            pending_review: null,
                            pending_connect: null,
                            error_account_connector: null
                        }
                    };

                    fila.id = companies[i].id;
                    fila.del = companies[i].del; 
                    fila.name = companies[i].name; 
                    fila.states.all = companies[i].all;
                    fila.states.done = companies[i].done;
                    fila.states.errors = companies[i].errors; 
                    fila.states.deleted = companies[i].deleted;  
                    fila.states.pending = companies[i].pending; 
                    fila.states.deleted_done = companies[i].deleted_done; 
                    fila.states.pending_sync = companies[i].pending_sync;  
                    fila.states.pending_review = companies[i].pending_review;
                    fila.states.pending_connect = companies[i].pending_connect;
                    fila.states.error_account_connector = companies[i].error_account_connector;
                    if(fila.name === "Total" || selected_field === "Todos los campos"){
                        filas.push(fila);
                    }else{
                        switch(selected_field){
                            case "Todos":
                                if (companies[i].all>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Contabilizados":
                                if (companies[i].done>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Errores":
                                if (companies[i].errors>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Borrados":
                                if (companies[i].deleted>0){
                                    filas.push(fila);
                                }
                                break;
                            case "En proceso":
                                if (companies[i].pending>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Borr. Cont":
                                if (companies[i].deleted_done>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Pdte. Sinc.":
                                if (companies[i].pending_sync>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Pdte. revisión":
                                if (companies[i].pending_review>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Contabilizando":
                                if (companies[i].pending_connect>0){
                                    filas.push(fila);
                                }
                                break;
                            case "Error Cont.":
                                if (companies[i].error_account_connector>0){
                                    filas.push(fila);
                                }
                                break;
                            case "":
                                filas.push(fila);
                        }
                    }
            }
        }
        let total_all = 0
        let total_done = 0
        let total_errors = 0
        let total_deleted = 0
        let total_pending = 0
        let total_deleted_done = 0
        let total_pending_sync = 0
        let total_pending_review = 0
        let total_pending_connect = 0
        let total_error_account_connector = 0
        filas.forEach(fila => {
            if(fila.name==="Total"){
                fila.states.all = total_all
                fila.states.done = total_done
                fila.states.errors = total_errors
                fila.states.deleted = total_deleted
                fila.states.pending = total_pending
                fila.states.deleted_done = total_deleted_done
                fila.states.pending_sync = total_pending_sync
                fila.states.pending_review = total_pending_review
                fila.states.pending_connect = total_pending_connect
                fila.states.error_account_connector = total_error_account_connector
            }else{
                total_all += fila.states.all
                total_done += fila.states.done
                total_errors += fila.states.errors
                total_deleted += fila.states.deleted
                total_pending += fila.states.pending
                total_deleted_done += fila.states.deleted_done
                total_pending_sync += fila.states.pending_sync
                total_pending_review += fila.states.pending_review
                total_pending_connect += fila.states.pending_connect
                total_error_account_connector += fila.states.error_account_connector
            }
        });
        return filas;
    }
}